import { useContext, useEffect } from "react";
import { useRouter } from "next/router";

import { ModalContext } from "@/contexts/ModalsContext";

import { NotifiTypes } from "@/types/UX.types";

import styles from "@/styles/components.module.scss";

interface NotificationProps {
    title?: string;
    timeout: number;
};

const Notification = ({ title, timeout }: NotificationProps) => {
    const { modalState: { notifi }, dispatchModal } = useContext(ModalContext);
    const router = useRouter();

    let notifiTimer: NodeJS.Timeout;

    const runNotifiTimer = () => {
        notifiTimer = setTimeout(() => {
            dispatchModal({ type: "SET_NOTIFI", notifi: null });
        }, timeout);
    };

    useEffect(() => {
        if (notifi?.show) {
            runNotifiTimer();
        }

        return () => clearTimeout(notifiTimer);
    }, [notifi?.show]);

    useEffect(() => {
        if (notifi?.show) {
            dispatchModal({ type: "SET_NOTIFI", notifi: null });
        }
    }, [router.pathname]);

    if (!notifi) return null;

    const notificationIcon = (nt: NotifiTypes) => {
        switch(nt) {
            case "OK":
                return <i className="fa fa-check-circle" aria-hidden="true"></i>;
            case "INFO":
                return <i className="fa fa-info-circle" aria-hidden="true"></i>;
            case "ERROR":
                return <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>;
            case "WARN":
                return <i className="fa fa-exclamation" aria-hidden="true"></i>;
            default:
                return <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>;
        }
    };

    return (
        <div className={styles[`notification-box`]}>
            <div className={`${styles["notification-sign"]} ${styles[`notification-sign--${notifi.notifiType?.toLowerCase()}`]}`}>
                {notificationIcon(notifi.notifiType!)}
            </div>

            <div className={styles[`notification-message`]}>
                {title && <p>{title}</p>}
                {/* <h4>{message}</h4> */}
                {notifi.message && <p dangerouslySetInnerHTML={{
                    __html: notifi.message
                }} />}
                {/* {subText && <small>({subText})</small>} */}
            </div>

        </div>
    );
};

export default Notification;
